import { z } from 'zod';

export const BookingInquiryProfitItem = z.object({
  tax_excluded_total_price: z.number(),
  excise_tax: z.number(),
  tatekae_total_price: z.number(),
});

export type BookingInquiryProfitItem = z.infer<typeof BookingInquiryProfitItem>;

export const BookingInquiryProfit = z.object({
  invoice: BookingInquiryProfitItem.nullish(),
  payment: BookingInquiryProfitItem.nullish(),
});

export type BookingInquiryProfit = z.infer<typeof BookingInquiryProfit>;
